import React, { useState } from "react";
import { Box, Paper, Tab, Tabs, Typography } from "@mui/material";
import RadioIcon from "@mui/icons-material/Radio";
import SettingsInputAntennaIcon from "@mui/icons-material/SettingsInputAntenna";
import SimCardIcon from "@mui/icons-material/SimCard";
import BatteryChargingFullIcon from "@mui/icons-material/BatteryChargingFull";
import DevicesOtherIcon from "@mui/icons-material/DevicesOther";
import Inventory2Icon from "@mui/icons-material/Inventory2";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import DashboardLayout from "../../../layouts/DashboardLayout";
import RegistroEquipoForm from "../components/RegistroEquipoForm";
import RegistrarAccesorioForm from "../components/RegistrarAccesorioForm";
import TransferirAccesorioForm from "../components/TransferirAccesorioForm";

// Cada equipo serializado se registra con RegistroEquipoForm; solo cambian sus campos. `persistir` = se conserva al registrar el siguiente.
const EQUIPOS = [
  { tipo: "radio", etiqueta: "Radio", titulo: "Radio", color: "primary", icono: RadioIcon, clave: { name: "serie", label: "Serie", maxLength: 30 } },
  {
    tipo: "modem", etiqueta: "Módem", titulo: "Módem", color: "info", icono: SettingsInputAntennaIcon, cliente: true,
    clave: { name: "num_sim", label: "Número de serie", maxLength: 30 },
    extras: [{ name: "id", label: "ID", required: true, maxLength: 30 }, { name: "emai", label: "IMEI", maxLength: 50 }],
  },
  {
    tipo: "chip", etiqueta: "Chip", titulo: "Chip", color: "secondary", icono: SimCardIcon,
    clave: { name: "numero", label: "Número", maxLength: 30 },
    extras: [{ name: "emai", label: "ICC", required: true, maxLength: 25 }, { name: "num", label: "Número de línea", required: true, maxLength: 30 }],
  },
  { tipo: "bateria", etiqueta: "Batería", titulo: "Batería", color: "success", icono: BatteryChargingFullIcon, clave: { name: "serie", label: "Serie", maxLength: 30 } },
  {
    tipo: "varios", etiqueta: "Equipos varios", titulo: "Equipo vario", color: "warning", icono: DevicesOtherIcon, clave: { name: "serie", label: "Serie", maxLength: 30 },
    extras: [
      { name: "emai", label: "IMEI / código", required: true, maxLength: 200 },
      { name: "proveedor", label: "Proveedor", maxLength: 70, persistir: true },
      { name: "factura", label: "Número de factura", maxLength: 30, persistir: true },
      { name: "fecha_compra", label: "Fecha de compra", type: "date", persistir: true },
    ],
  },
];

const ESTILO_TABS = { minHeight: 34, "& .MuiTab-root": { minHeight: 34, py: 0.5, fontSize: 12, fontWeight: 700, textTransform: "none" } };

export default function RegistroEquiposPage() {
  const [tab, setTab] = useState(0);
  const iconoTab = (Icono) => <Icono fontSize="small" />;

  return (
    <DashboardLayout>
      <Box sx={{ width: "100%" }}>
        <Typography variant="h6" sx={{ mb: 1 }}>Registro de equipos</Typography>
        <Paper variant="outlined" sx={{ mb: 1, overflow: "hidden" }}>
          <Tabs value={tab} onChange={(_, value) => setTab(value)} variant="scrollable" scrollButtons="auto" sx={ESTILO_TABS}>
            {EQUIPOS.map((e) => <Tab key={e.tipo} icon={iconoTab(e.icono)} iconPosition="start" label={e.etiqueta} />)}
            <Tab icon={iconoTab(Inventory2Icon)} iconPosition="start" label="Accesorio" />
            <Tab icon={iconoTab(SwapHorizIcon)} iconPosition="start" label="Transferir accesorio" />
          </Tabs>
        </Paper>

        {EQUIPOS.map((e, i) => tab === i && <RegistroEquipoForm key={e.tipo} cfg={e} />)}
        {tab === EQUIPOS.length && <RegistrarAccesorioForm />}
        {tab === EQUIPOS.length + 1 && <TransferirAccesorioForm />}
      </Box>
    </DashboardLayout>
  );
}
